import ajaxKeywords from './ajax/keywords.js'
import ajaxSearchProducts from "./ajax/search-product";
import ajaxProductsCategory from "./ajax/category-product";
import initWoocommerceTabs from "./module/woocommerce-tabs";
import initToggle from "./module/tabs";
import initPagination from "./module/pagination";

document.addEventListener("DOMContentLoaded", function () {
    ajaxKeywords();
    ajaxSearchProducts();
    ajaxProductsCategory();
    initWoocommerceTabs();
    initPagination();
    initToggle();
});